import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const useSupplierAutofill = (supplierList = []) => {
  const { watch, setValue } = useFormContext();
  const supplierName = watch('supplierName');

  useEffect(() => {
    if (!supplierName) return;

    if (supplierName === 'Other') {
      // Let the user type both the name and email manually — nothing to autofill
      setValue('emailToSupplier', '', { shouldDirty: true });
      return;
    }

    // Not "Other" anymore — clear any leftover free-text name from a prior selection
    setValue('otherSupplierName', '', { shouldDirty: false });

    const match = supplierList.find(s => s.supplierName === supplierName);
    setValue('emailToSupplier', match?.supplierEmail || '', { shouldDirty: true });
  }, [supplierName, supplierList, setValue]);
};

export default useSupplierAutofill;